import axios from "axios";
import { API } from "./client";

export const createComparison   = ()              => axios.post(`${API}/compare/create`, {});
export const uploadCompareFile  = (formData)      => axios.post(`${API}/compare/upload`, formData);
export const findLatestRevision = (formData)      => axios.post(`${API}/compare/find-latest`, formData);
export const runComparison      = (formData)      => axios.post(`${API}/compare/run`, formData);
export const sendCompareChat    = (data)          => axios.post(`${API}/compare/chat`, data);
export const getComparison      = (id)            => axios.get(`${API}/compare/${id}`);
export const getCompareChat     = (id)            => axios.get(`${API}/compare/${id}/chat`);
export const getComparePage     = (id, role, n)   => axios.get(`${API}/compare/${id}/page/${role}/${n}`);
export const exportComparisonCsv   = (id) => axios.get(`${API}/compare/${id}/export/csv`, { responseType: "blob" });
export const exportComparisonExcel = (id) => axios.get(`${API}/compare/${id}/export/excel`, { responseType: "blob" });

export const compareFromVersionHistory = (itemId, projectId) =>
  axios.post(`${API}/compare/from-version-history`,
    new URLSearchParams({ item_id: itemId, project_id: projectId }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
  );
